import "./App.css";
import { useState } from "react";
//import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

function App() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const pressVideos = [
    `${process.env.PUBLIC_URL}/pressVideo/press1.mp4`,
    `${process.env.PUBLIC_URL}/pressVideo/press2.mp4`,
  ];

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  return (
    <div className="App">
      {/* Navigation Header */}
      <nav className="navbar">
        <div className="nav-container">
          <img src="/LOGO.jpg" alt="APEX AUTOMATION LLC" className="logo" />

          {/* Hamburger Menu Button */}
          <button
            className={`hamburger ${isMenuOpen ? "active" : ""}`}
            onClick={toggleMenu}
            aria-label="Toggle navigation menu"
          >
            <span></span>
            <span></span>
            <span></span>
          </button>

          {/* Navigation Links */}
          <div className={`nav-links ${isMenuOpen ? "active" : ""}`}>
            {/* Close Button for Mobile Menu */}
            <button
              className="close-menu-btn"
              onClick={closeMenu}
              aria-label="Close menu"
            >
              x
            </button>
            <a href="#about" onClick={closeMenu}>
              About
            </a>
            <a href="#services" onClick={closeMenu}>
              Services
            </a>
            <a href="#experience" onClick={closeMenu}>
              Experience
            </a>
            <a href="#completed-work" onClick={closeMenu}>
              Completed Work
            </a>
            <a href="#why-choose-us" onClick={closeMenu}>
              Why Choose Us
            </a>
            <a href="#contact" onClick={closeMenu}>
              Contact
            </a>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="hero">
        <div className="hero-content">
          <h1>APEX AUTOMATION LLC</h1>
          <p className="hero-subtitle">
            Innovative Automation & Electrical Solutions
          </p>
          <p className="hero-description">
            Trusted partner in delivering automation and electrical solutions
            that empower businesses to operate more efficiently, safely, and
            reliably.
          </p>
          <a href="#contact" className="cta-button">
            Get Started Today
          </a>
        </div>
      </section>

      {/* About Section */}
      <section id="about" className="about">
        <div className="container">
          <h2>Who We Are</h2>
          <p>
            At <strong>APEX AUTOMATION LLC</strong>, we are a trusted partner in
            delivering innovative automation and electrical solutions that
            empower businesses to operate more efficiently, safely, and
            reliably. Backed by over a decade of industry experience, our team
            brings hands-on expertise and a commitment to quality workmanship to
            every project we take on.
          </p>
          <p>
            Our mission is simple: to provide top-tier automation and electrical
            services that help our clients save time, reduce costs, and improve
            productivity—while ensuring compliance with the highest industry
            standards.
          </p>
          <p>
            We pride ourselves on being approachable, dependable, and dedicated
            to building lasting partnerships with the businesses we serve.
          </p>
        </div>
      </section>

      {/* Services Section */}
      <section id="services" className="services">
        <div className="container">
          <h2>What We Do</h2>
          <p className="services-intro">
            <strong>APEX AUTOMATION LLC</strong> specializes in custom
            automation and electrical services for industrial, commercial,
            agricultural, and municipal clients. Our team has the technical
            skill and field experience to design, install, troubleshoot, and
            maintain systems that keep your operations running at their best.
          </p>

          <div className="services-grid">
            <div className="service-card">
              <h3>Industrial Automation</h3>
              <ul>
                <li>
                  PLC programming & integration (Allen-Bradley, Siemens, etc.)
                </li>
                <li>SCADA system design & implementation</li>
                <li>HMI development and optimization</li>
                <li>Control panel design, assembly, and commissioning</li>
              </ul>
            </div>

            <div className="service-card">
              <h3>Electrical Services</h3>
              <ul>
                <li>Industrial and commercial wiring & installations</li>
                <li>Preventative maintenance and troubleshooting</li>
                <li>Motor control centers (MCC) setup and service</li>
                <li>Power distribution systems</li>
              </ul>
            </div>

            <div className="service-card">
              <h3>Process Control & Optimization</h3>
              <ul>
                <li>Custom automation solutions tailored to client needs</li>
                <li>System upgrades and retrofits for aging equipment</li>
                <li>
                  Efficiency improvements to reduce downtime and energy usage
                </li>
              </ul>
            </div>

            <div className="service-card">
              <h3>Field Support & Maintenance</h3>
              <ul>
                <li>On-site diagnostics and repair services</li>
                <li>Preventative maintenance programs</li>
                <li>Emergency electrical and automation support</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Experience Section */}
      <section id="experience" className="experience">
        <div className="container">
          <h2>Past Experience & Expertise</h2>
          <p>
            With more than ten years of hands-on work in the automation and
            electrical service industry, we have contributed to projects across
            diverse industries, including:
          </p>

          <div className="experience-grid">
            <div className="experience-item">
              <h4>Manufacturing plants</h4>
              <p>Automating production lines for efficiency and safety.</p>
            </div>
            <div className="experience-item">
              <h4>Water & wastewater facilities</h4>
              <p>Installing and maintaining SCADA/PLC systems.</p>
            </div>
            <div className="experience-item">
              <h4>Food & beverage industry</h4>
              <p>
                Ensuring compliance, reliability, and precision in operations.
              </p>
            </div>
            <div className="experience-item">
              <h4>Commercial facilities</h4>
              <p>Electrical installations and long-term system support.</p>
            </div>
            <div className="experience-item">
              <h4>Agricultural and grain elevator systems</h4>
              <p>
                Powering efficient, reliable, and safe handling and storage
                operations.
              </p>
            </div>
          </div>

          <p className="experience-summary">
            This breadth of experience gives us the confidence to tackle
            projects of any size, from small upgrades to full system
            installations.
          </p>
        </div>
      </section>
      {/* Completed Work Section */}
      <section id="completed-work" className="completed-work">
        <div className="container">
          <h2>Our Completed Work</h2>
          <p className="work-intro">
            Take a look at some of our recent projects showcasing our expertise
            in panel fabrication and industrial automation.
          </p>

          <div className="work-category">
            <h3>Control Panel Process</h3>
            <p>
              Swipe to see the step-by-step progression of our custom control
              panel fabrication:
            </p>
            <div className="panel-carousel-container">
              {/* <Slider
                dots={true}
                infinite={true}
                speed={500}
                slidesToShow={1}
                slidesToScroll={1}
                arrows={true}
                adaptiveHeight={true}
              > */}
              <div className="panel-slide">
                <img src="/panel/panel4.jpg" alt="Control Panel Step 4" />
              </div>
              <span>
                150 HP Drive panel build to replace forward reversing contactors
                and add variable speed. Fed from Machine Power with electrical
                interlock
              </span>
              {/* </Slider> */}
            </div>
          </div>

          <div className="work-category">
            <h3>Press-Ready Panels</h3>
            <p>
              Watch two quick walkthroughs highlighting the craftsmanship that
              goes into every project.
            </p>
            <div className="video-grid">
              {pressVideos.map((videoSrc, index) => (
                <div className="video-item" key={videoSrc}>
                  <video
                    src={videoSrc}
                    muted
                    controls
                    preload="metadata"
                    playsInline
                    aria-label={`Press-ready panel walkthrough ${index + 1}`}
                  >
                    Your browser does not support the video tag.
                  </video>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Why Choose Us Section */}
      <section id="why-choose-us" className="why-choose-us">
        <div className="container">
          <h2>Why Choose Us?</h2>
          <div className="benefits-grid">
            <div className="benefit-item">
              <h3>Over a Decade of Expertise</h3>
              <p>Proven success across multiple industries.</p>
            </div>
            <div className="benefit-item">
              <h3>Personalized Service</h3>
              <p>Tailored solutions for your unique needs.</p>
            </div>
            <div className="benefit-item">
              <h3>Commitment to Safety</h3>
              <p>Compliance and safety are always top priorities.</p>
            </div>
            <div className="benefit-item">
              <h3>Reliable Support</h3>
              <p>Prompt response when downtime isn't an option.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section id="contact" className="contact">
        <div className="container">
          <h2>Ready to Get Started?</h2>
          <p className="contact-intro">
            Contact{" "}
            <a href="mailto:services@aallcoh.com" className="email-link">
              services@aallcoh.com
            </a>{" "}
            today to discuss your next project.
          </p>
        </div>
      </section>

      {/* Footer */}
      <footer className="footer">
        <div className="container">
          <img
            src="/LOGO.jpg"
            alt="APEX AUTOMATION LLC"
            className="footer-logo"
          />
          <p>&copy; 2025 APEX AUTOMATION LLC. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
}

export default App;
